import { OrganType } from '@nkr/enums/organ-type';

export interface IAddEditData {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    confirmPassword: string,
    username: string,
    centerId: number,
    groupId: number,
    courierVendor: number,
    isMicrositeCoach: boolean,
    contactId: number,
    donorConnectCaseLoad: number,
    roles: number[],
    sendTicketNotification: boolean,
    isDeactivated: boolean,
    mobileNumber: string,
    isTwoFactorEnabled: boolean,
    organTypeId: number,
    opoId: number
}